import State from '@/store/state';
import { Report } from '@/store/types';

// eslint-disable-next-line import/prefer-default-export
export const reportTemplateGet = (state: State): Report['template'] | null =>
	state.report && state.report.template;
